import style from "./Input.module.scss";

interface InputProps {
  placeholder: string;
  value: string;
  onChangeFunc: (value: string) => void;
  disabled?: boolean;
  onBlur?: () => void;
  isDark?: boolean;
  id: string;
  isTel?: boolean;
}

export default function Input({
  placeholder,
  value,
  onChangeFunc,
  disabled = false,
  onBlur,
  isDark = false,
  id = "input",
  isTel = false
}: InputProps) {
  return (
    <input
      type={isTel ? "tel" : "text"}
      placeholder={placeholder}
      className={`text-stone-500 border border-neutral-200 outline-none focus:border-primary-blue w-full xl:w-full ${isDark ? style.Input__Field_Dark : style.Input__FieldFont}`}
      value={value}
      onChange={(e) => onChangeFunc(e.target.value)}
      disabled={disabled}
      onBlur={onBlur}
      id={id}
    />
  );
}